/**
 * ContactHero — `/contact` page body.
 *
 * Verbatim render of the user-uploaded `contact_1.html` design. CSS / HTML / JS
 * live in `./landing/contact/{styles,markup,script}.js`.
 *
 * `wireLinks={true}` is harmless here (the markup has no internal route
 * anchors) and keeps behaviour consistent with the other PageHost pages.
 *
 * The form's `fetch('/api/contact')` is same-origin and works in both
 * preview and production because the ingress routes `/api/*` to the
 * FastAPI backend regardless of host. No JS modification needed.
 */
import { STYLES } from "./landing/contact/styles";
import { MARKUP } from "./landing/contact/markup";
import { SCRIPT } from "./landing/contact/script";
import { PageHost } from "./landing/PageHost";

export function ContactHero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-contact-host"
      wireLinks={true}
      data-testid="contact-hero"
    />
  );
}
